<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
    data() {
        return {
            changeColor: '#0866b4' // 后台返回的色值
        }
    },
    computed: {
        colorProps() {
           return {
               'moveColor': this.changeColor
           }
        }
    }
}
</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body {
  box-sizing: border-box;
  --themeColor: #396EE5;
  --themeColor1: #396EE5;
  --themeColor6: #3656a1;
  --themeSloganColor: #3656a1;
}
#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
// 轮播banner
.carousel {
  position: absolute;
  // left: 0;
  // top: 0;
  width: 100%;
}
.ban_l {
  // flex: 1;
  // margin-top: 88px;
  z-index: 99;
  text-align: left;
  width: 70%;
  color: #fff;
  .tit {
      font-weight: 900;
      font-size: 40px;
    }
    .desc {
      margin-top: 10px;
      font-size: 18px;
      // color: #7a8ba4;
      -webkit-line-clamp: 4;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #fff;
  }
}
.disable_class{
  background: #efefef;
  // color: #999;
  border-radius: 8px;
  padding: 6px 8px;
  cursor:not-allowed;
  text-align: center;
}
.sloganColor{
  color: var(--themeSloganColor);
}
.tabs {
  border-radius: 8px;
  justify-content: center;
  flex-wrap: wrap;
  .bon {
    font-size: 18px;
    color: #374567;
    cursor: pointer;
    background: var(--themeColor1);
    padding: 1.063rem 0;
    margin-left: 24px;
    flex: 1;
    // min-width: 212px;
    &:first-child {
      margin-left: 0;
    }
  }
  .click_sty {
    color: #fff;
    background: var(--themeColor);
    position: relative;
  }
  .click_sty::after{
    content: '';
    position: absolute;
    left: 50%;
    bottom: -10px;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid var(--themeColor);
  }
}
</style>
